import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_FILTERS,
  currentFiltersSelector,
  setFilterValue,
} from 'features/courseResume';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';
import SuperBatchSelect from 'components/SuperBatchSelect';

function NewBatchFilter() {
  const dispatch = useDispatch();
  const { newBatch } = useSelector(currentFiltersSelector);
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setFilterValue({
          key: COURSE_PAUSE_REQUEST_FILTERS.newBatch,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="New Batch"
      labelClassName="h5"
    >
      <SuperBatchSelect
        styles={_styles}
        placeholder="Select from dropdown"
        value={newBatch}
        onChange={handleOnChange}
      />
    </Field>
  );
}

export default NewBatchFilter;
